import { useCallback } from "react";
import { Menu, Placeholder, Segment, Table } from "semantic-ui-react";

import styles from "../assets/styles/placeholder-window.module.css";

import { LazyLoadingBar } from "./LazyLoadingBar";

type Props = {
    type: "table" | "form" | string;
};

const PAGE_SIZE = 1;
const COLUMN_COUNT = 6;

export const PlaceholderWindow = ({ type }: Props) => {
    const getTablePlaceholder = useCallback(
        () => (
            <Segment className={styles.tableContainer} attached="bottom" raised>
                <Table
                    size="small"
                    celled
                    selectable={false}
                    definition={false}
                    sortable={false}
                    compact
                    singleLine
                    structured
                    attached="bottom"
                >
                    <Table.Header>
                        <Table.Row>
                            {Array.from(new Array(COLUMN_COUNT)).map(
                                (_data, headerId) => (
                                    <Table.HeaderCell
                                        key={`placeholder-header-${headerId}`}
                                    >
                                        <Placeholder>
                                            <Placeholder.Paragraph
                                                className={styles.tableLine}
                                            >
                                                <Placeholder.Line />
                                            </Placeholder.Paragraph>
                                        </Placeholder>
                                    </Table.HeaderCell>
                                )
                            )}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {Array.from(new Array(PAGE_SIZE)).map(
                            (_data, rowId) => (
                                <Table.Row key={`placeholder-row-${rowId}`}>
                                    {Array.from(new Array(COLUMN_COUNT)).map(
                                        (_data, columnId) => (
                                            <Table.Cell
                                                key={`placeholder-column-${columnId}`}
                                            >
                                                <Placeholder>
                                                    <Placeholder.Paragraph
                                                        className={
                                                            styles.tableLine
                                                        }
                                                    >
                                                        <Placeholder.Line />
                                                    </Placeholder.Paragraph>
                                                </Placeholder>
                                            </Table.Cell>
                                        )
                                    )}
                                </Table.Row>
                            )
                        )}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            {Array.from(new Array(COLUMN_COUNT)).map(
                                (_data, footerId) => (
                                    <Table.HeaderCell
                                        key={`placeholder-footer-${footerId}`}
                                    >
                                        <br />
                                    </Table.HeaderCell>
                                )
                            )}
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </Segment>
        ),
        []
    );

    const getFormPlaceholder = useCallback(
        () => (
            <Segment attached="bottom" raised>
                <Placeholder fluid>
                    <Placeholder.Paragraph>
                        <Placeholder.Line
                            className={styles.formLine}
                            length="long"
                        />
                        <Placeholder.Line
                            className={styles.formLine}
                            length="medium"
                        />
                        <Placeholder.Line
                            className={styles.formLine}
                            length="very short"
                        />
                        <Placeholder.Line
                            className={styles.formLine}
                            length="short"
                        />
                    </Placeholder.Paragraph>
                </Placeholder>
                <Placeholder fluid>
                    <Placeholder.Paragraph>
                        <Placeholder.Line
                            className={styles.formLine}
                            length="short"
                        />
                        <Placeholder.Line
                            className={styles.formLine}
                            length="very long"
                        />
                        <Placeholder.Line
                            className={styles.formLine}
                            length="medium"
                        />
                        <Placeholder.Line
                            className={styles.formLine}
                            length="long"
                        />
                    </Placeholder.Paragraph>
                </Placeholder>
            </Segment>
        ),
        []
    );

    return (
        <>
            <LazyLoadingBar />
            <Segment className={styles.titleContainer} attached="top" raised>
                <Placeholder fluid>
                    <Placeholder.Header className={styles.icon} image>
                        <Placeholder.Line
                            className={styles.title}
                            length="very short"
                        />
                        <Placeholder.Line length="short" />
                    </Placeholder.Header>
                </Placeholder>
            </Segment>
            <Menu attached borderless>
                <Menu.Item
                    content={
                        <Placeholder style={{ height: 20, width: 20 }}>
                            <Placeholder.Image />
                        </Placeholder>
                    }
                    disabled
                />
                <Menu.Item
                    content={
                        <Placeholder style={{ height: 20, width: 20 }}>
                            <Placeholder.Image />
                        </Placeholder>
                    }
                    disabled
                />
                <Menu.Item
                    content={
                        <Placeholder style={{ height: 20, width: 20 }}>
                            <Placeholder.Image />
                        </Placeholder>
                    }
                    disabled
                />
            </Menu>
            {type === "table" && getTablePlaceholder()}
            {type === "form" && getFormPlaceholder()}
        </>
    );
};
